<template>
  <v-app
    class='white'
    light
  >
    <v-content>
     <sHeader title='My Genetic Trust Concierge'/>
      <section>
        <v-layout
          row
          wrap
          align-center
          class="my-12"
        >

          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout
                row
                align-center
              >
                <v-flex
                  xs12
                  md8
                >
                  <v-card

                    flat
                    class="transparent"
                  >

                    <v-card-text>

                      <p class='headline font-weight-regular'>
                      Let our certified
                      genetic counselors customize the process for you. We will work with you and your
                      family members to obtain and organize important records and facilitate your DNA banking.
                      </p>

                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-card
                    flat
                    class="transparent"
                  >
                    <v-card-text class="text-center">
                      <img src='../../assets/staticAsset/GSF_InitialStyleSketches-scientist-green.png' />
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex

                  xs12
                  md8
                >
                  <v-card

                    flat
                    class="transparent"
                  >

                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">Process</p>
                      <p class='font-weight-regular title'>
                        We will begin by scheduling an appointment to review your health and family history by phone or video conference with a certified genetic counselor. Through this initial meeting we will identify the key medical records to request and health and family history to clarify, and our team will take all steps to gather and record all necessary information.  We will be present throughout the entire process, ensuring that the records and documentation in your My Genetic Trust are as complete and accurate as possible.
                      </p>
                      <p class='font-weight-regular title'>
                      In addition, we will facilitate collection and banking of your DNA*.
                      DNA banking is another tool that can be helpful to preserve information
                      about your family health history. Through this process, your DNA is
                      removed from either a blood or saliva sample. This extracted DNA can
                      be stored in a secure facility for decades to come, and genetic testing
                      can be done at a later date when results are more likely to be informative
                      for the benefit of your family members. We will coordinate DNA Banking to
                      be done at a reputable facility and ensure that you and your loved ones
                      have the information needed to access this DNA sample for any future needs.<br>
                      </p>
                      <p class='font-weight-regular title'>
                       All of your documents will be carefully reviewed by one of our certified genetic counselors.  In some cases, recommendations for specific screening or changes in health management may be made based on the health information you provide. This careful documentation of the health history and our current understanding of inherited risk for disease will be included as part of the Genetic Trust documents.
                        </p>
                         <p class='font-weight-regular title'>
                           You and your named beneficiaries will be able to access your complete family health history and final My Genetic Trust report through a secure HIPAA-compliant portal at any time.
                        </p>

                        <span class="pt-10 subtitle-1">* You and your beneficiaries will own your DNA; it is against our policies and ethics to sell DNA.</span>
                    </v-card-text>

                  </v-card>
                </v-flex>

                <v-flex

                  xs12
                  md4
                >
                <p class="title font-weight-bold mainBlue">My Genetic Trust Concierge Details</p>
                  <v-card
                    :outlined='true'
                    class="green-border"
                  >
                    <v-card-text>
                      <p class='subtitle-1 '>Guide for family history collection</p>
                       <v-divider class='featureCard' insert></v-divider>
                       <p class='subtitle-1 '>Guide for medical record collection</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1 '>Family Health Tree Worksheet</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1 '>Genetic counselor reviews medical and family history</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1 '>Generate a My Genetic Trust report</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1 '>Storage of medical and family history</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1 '>DNA Banking</p>
                       <v-divider class='featureCard' insert></v-divider>
                        <p class='subtitle-1 '>Expert support</p>
                    </v-card-text>
                    <br/>
                  </v-card>
                   <v-card  flat class="transparent">
                    <v-card-text>
                   <p class="mt-7 title font-weight-bold mainBlue" >View our Other Plans</p>
                  <a class="font-weight-regular title  green--text" href="/public/plus">My Genetic Trust Plus</a>
                   <br />
                  <a class="font-weight-regular title  green--text" href="/public/complete">My Genetic Trust Complete</a>
                     </v-card-text>
                  </v-card>

                </v-flex>

                 <v-flex
                 xs12
                  md8>
                  <v-card  flat class="transparent">
                    <v-card-text>
                      <p class="title font-weight-bold mainBlue">Annual Updates</p>
                        <p class='font-weight-regular  title'>Your annual subscription will allow you to add any new family members, new genetic information, or health history at any time during your subscription year.</p>
                       <br />
                       <p class=" title font-weight-bold mainBlue">Pricing</p>
                       <p class='font-weight-regular title'>Your package includes one year of updates. If you wish to continue services after your initial year, you will need to sign up for an annual update subscription plan.</p>


                            <p class="title">Contact us for a customized pricing estimate.</p>
                            <p class="title"><v-icon class='mr-2'>phone</v-icon>844.743.6384</p>



                          <p class='subtitle-1'>You can cancel your subscription at any time and will be provided your
                        <span class='font-weight-black'>My Genetic Trust Report</span> and all documentation we have on file at time
                        of cancellation.</p>
                        <signupButton
                          :dark='true'
                          :large='true'
                          color='#399342'
                          :plan='2'
                          buttonText="Sign up for Genetic Trust Concierge"/>
                        <!-- <v-btn large  href="Signup">Sign up for Genetic Trust Concierge</v-btn> -->
                    </v-card-text>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-container>
          </v-flex>
              </v-layout>

      </section>

      <!-- footer section -->
      <v-footer
        class='footer white'
        color="darken-2"
      >
     <sfooter />
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import sHeader from "../../components/staticPage/Header"
import signupButton from "../../components/Signup"
import sfooter from "../../components/staticPage/Footer"
export default {
    components : {
    sfooter,
    signupButton,
    sHeader
  },
  mounted () {
  }
}
</script>

<style scoped>
.mainBlue {
  color: #399342;
}
.featureCard{
  margin-bottom : 1%
}
p {
font-weight : bold
}
</style>
